// @flow
export { default } from './FakePostCard';



// WEBPACK FOOTER //
// ./src/components/common/FakePostCard/index.js